module.exports = __webpack_public_path__ + "components/flag/static/square/cg-4ba1158dc891240f6005d3e629eb0414.svg";